import React, { Component } from 'react'
import Address from 'features/Forms/Address'
import Button from 'components/Button'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import sText from 'components/Text/Text.scss'

export default class BillingAccountFormAddressStep extends Component {
  render() {
    const { change, prev, invalid, loading } = this.props

    return (
      <div>
        <div className={cn(sText.descrip1, sMarg.mt60, sMarg.mb30)}>2. Address</div>

        <Address change={change} />

        {prev && (
          <div
            className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
            style={{ marginTop: '40px' }}
          >
            <Button color="tertiary" type="submit" loading={loading} disabled={invalid || loading}>
              Next
            </Button>
            <br />
            <br />
            <Button plain onClick={prev}>
              Back
            </Button>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountFormAddressStep/BillingAccountFormAddressStep.jsx